import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor() {
    const title = document.querySelector('TITLE') as HTMLElement;
    title.innerText = 'Vietnam Food';
  }
}
